<template>
  <a-row :gutter="20">
    <a-col :span="6">
      模型列表
      <div class="voice-panel" >
        <a v-for="(item,index) in data">{{modelName(item)}}</a>
      </div>
    </a-col>
    <a-col :span="18">
      格式化高质量模型文本输出
      <div  class="voice-panel" v-html="current.result">

      </div>
    </a-col>

  </a-row>
</template>

<script>
  import { getAction ,postAction} from '@/api/manage'
  import { CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  export default {
    name: 'Item3',
    props:{
      data:{
        type:Array,
        default:()=>{
          return []
        }
      }
    },
    data(){
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        currentIndex:0,
        modelList:[],
      }
    },
    computed:{
      current(){
        if(this.data.length>0 && this.data.length-1 >= this.currentIndex){
          return this.data[this.currentIndex]
        }else{
          return {}
        }
      },

    },
    mounted(){
      getAction('/project/voiceConfig/listAll',{projectId:this.projectId,enabled:'1'}).then(res=>{
        if(res.success){
          this.modelList = res.result
        }
      })
    },
    methods:{
      itemClick(index){
        this.currentIndex = index
      },
      modelName(record){
        let result = {}
        if(record && this.modelList.length>0){
          this.modelList.forEach(item=>{
            if(item.code==record.modelCode){
              result = item.name
            }
          })
        }
        return result
      },
    }
  }
</script>

<style scoped lang="less">
  .voice-panel{
    padding: 10px
  }
  .left{
    min-height: 330px;
  }
  .item{
    margin-top: 10px;
  }
</style>